<button
  type="button"
  [ngClass]="[
    'app-button',
    className,
    variant,
    color,
    isLoading ? 'isLoading' : '',
    showIconOnMobile ? 'mobile-icon-only' : '',
  ]"
  [ngStyle]="getCustomStyles()"
  [disabled]="disabled || isLoading || isShowIconLoader"
  (click)="handleClick($event)"
>
  <ng-container *ngIf="isLoading; else notLoading">
    <span
      class="button-loader"
      [ngStyle]="{
        color: iconColor,
        width: loaderSize + 'px',
        height: loaderSize + 'px',
      }"
    ></span>
    <span class="loading-text">{{ loadingText }}</span>
  </ng-container>

  <ng-template #notLoading>
    <ng-container>
      <span
        *ngIf="icon && iconPosition === 'left'"
        #svgContainer
        class="btn-icon"
        [innerHTML]="icon"
        [ngStyle]="{ 'font-size': iconFontSize, color: iconColor }"
      ></span>

      <span
        *ngIf="svgIcon && !isShowIconLoader && iconPosition === 'left'"
        class="btn-icon"
      >
        <g99-icon-btn
          [icon]="svgIcon"
          [color]="iconColor"
          [colorStrategy]="iconColorStrategy"
          [height]="iconHeight"
          [width]="iconWidth"
        />
      </span>
    </ng-container>

    <!-- Always render external icon component separately -->
    <ng-content select="g99-icon-btn" />

    <!-- Text content (hidden on mobile via CSS when showIconOnMobile=true) -->
    <span class="button-text">
      <ng-content select=":not(g99-icon-btn)" />
    </span>

    <ng-container>
      <span
        *ngIf="icon && iconPosition === 'right'"
        #svgContainer
        class="btn-icon"
        [innerHTML]="icon"
        [ngStyle]="{ 'font-size': iconFontSize, color: iconColor }"
      ></span>

      <span
        *ngIf="svgIcon && !isShowIconLoader && iconPosition === 'right'"
        class="btn-icon"
      >
        <g99-icon-btn
          [icon]="svgIcon"
          [color]="iconColor"
          [colorStrategy]="iconColorStrategy"
        />
      </span>

      <span
        *ngIf="isShowIconLoader"
        class="button-loader"
        [ngStyle]="{
          color: iconColor,
          width: loaderSize + 'px',
          height: loaderSize + 'px',
        }"
      >
      </span>
    </ng-container>
  </ng-template>
</button>
